import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const locale = window.location.pathname.replace(/^\/([^/]+).*/i, '$1')
const i18n = new VueI18n({
  locale: locale === '/' ? 'el' : locale,
  fallbackLocale: 'el',
  messages: {
    el: {},
    en: {}
  }
})

export default i18n
